import React, { useState } from 'react';
import styled from 'styled-components';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';

import SegmentUpdatePane from '../../../containers/segment/update/Pane';
import SegmentUpdateStepContainer from '../../../containers/segment/update/StepContainer';
import SegmentUpdateStep from '../../../containers/segment/update/Step';
import SegmentStepFilter from '../../../containers/segment/update/StepFilter';
import SegmentUpdateHeader from './Header';

const StyledFunnelUpdatePaneContainer = styled.div`
  position: relative;
  display: flex;
  justify-content: space-between;
  border: 1px solid #999999;
  margin: 1px 1px 10px;
  background-color: #fff;
`;

const UpdateStep = ({ renderUpdateStepProps, showNotValidFields }) => {
  const { isDragging, attributes, listeners, setNodeRef, transform, transition } = useSortable({
    id: renderUpdateStepProps.id,
  });

  const style = {
    opacity: isDragging ? 0.4 : undefined,
    transform: CSS.Transform.toString(transform),
    transition,
  };

  return (
    <StyledFunnelUpdatePaneContainer ref={setNodeRef} style={style} {...attributes} {...listeners}>
      <SegmentUpdateStep
        showNotValidFields={showNotValidFields}
        {...renderUpdateStepProps}
        renderStepFilter={(renderStepFilterProps) => (
          <SegmentStepFilter {...renderStepFilterProps} />
        )}
      />
    </StyledFunnelUpdatePaneContainer>
  );
};

const SegmentUpdatePaneContainer = (props) => {
  const [showNotValidFields, setShowNotValidFields] = useState(false);

  return (
    <SegmentUpdatePane setShowNotValidFields={setShowNotValidFields} {...props}>
      <SegmentUpdateHeader showNotValidFields={showNotValidFields} />
      <SegmentUpdateStepContainer
        renderUpdateStep={
          (renderUpdateStepProps) => (
            <UpdateStep
              renderUpdateStepProps={renderUpdateStepProps}
              showNotValidFields={showNotValidFields}
            />
          )
          // renderUpdateStep(renderUpdateStepProps, showNotValidFields)
        }
      />
    </SegmentUpdatePane>
  );
};

export default SegmentUpdatePaneContainer;
